<template>
  <v-content pa-0>
    <Header></Header>
    <div
      style="position: relative;display: flex;justify-content: center;align-items: center"
      :style="$vuetify.breakpoint.mdAndUp ? {'padding-top': '88px'}:{}"
    >
      <v-img
        style="width: 100%"
        max-height="500px"
        :src="$vuetify.breakpoint.smAndDown ? http + researchReportBanner.mobile_img : http + researchReportBanner.desktop_img"
      ></v-img>
    </div>
    <loading :active.sync="isLoading"></loading>
    <template>
      <v-row class="mx-0 mt-5" >
        <v-col cols="12" sm="12" md="2" offset-md="1" offset-lg="0" lg="3" xl="3"  >
<!--          <v-sheet rounded="lg">-->
            <v-layout justify-center mt-3 mb-5 class="coloredTxt"
                      :class="{'column':$vuetify.breakpoint.smAndDown}">
              <v-row>
                <v-col cols="10" offset="1">
                  <v-flex shrink
                    :class="{'mx-7':$vuetify.breakpoint.smAndDown,'mr-3':$vuetify.breakpoint.mdAndUp}">
                  <v-select v-model="selectedCategory"
                      :items="industries"
                      color="#FF5100"

                      :label="$t('industryCategory')"
                      @change="onIndustryChanged"
                      outlined
                  ></v-select>
                </v-flex>
                </v-col>
                <v-col cols="10" offset="1">
                  <v-flex shrink
                    :class="{'mx-7':$vuetify.breakpoint.smAndDown,'mr-3':$vuetify.breakpoint.mdAndUp}">
                  <v-text-field clearable v-model="keyword" outlined :label="$t('keyword')" color="#FF5100"></v-text-field>
                </v-flex>
                </v-col>
                <v-col cols="10" offset="1">
                  <v-flex shrink
                    :class="{'ml-3':$vuetify.breakpoint.mdAndUp,'mr-10':$vuetify.breakpoint.mdAndUp,}">
                  <div :class="{'pt-3':$vuetify.breakpoint.mdAndUp}" @click="onSearchClicked">
                    <v-btn class="white--text" style="width: 100px" color="#FF5100">{{$t('search')}}</v-btn>
                  </div>
                </v-flex>
                </v-col>
              </v-row>

            </v-layout>
<!--          </v-sheet>-->
        </v-col>

        <v-col cols="12" sm="12" md="8" lg="9" xl="7"><v-sheet rounded="lg">
            <template>
              <v-layout justify-start mb-7 v-if="$vuetify.breakpoint.mdAndUp">
                <v-flex pa-5 align-center style="display: flex" class="headIndex">
                  <img
                      class="mx-5"
                      width="auto"
                      height="35px"
                      :src="require('../assets/icon/report_orange.png')"
                  />
                  <div class="text-start">{{ $t('research-report') }}</div>
                </v-flex>
              </v-layout>

              <v-layout justify-center>
                <v-flex xs12 lg11>
                  <ReportGroup group="report" :list="activeArticles"></ReportGroup>
                </v-flex>
              </v-layout>
              <v-layout justify-center v-if="has_more">
                <v-flex xs12 lg11 class="ma-5">
                  <v-btn color="#FF4F23" style="color: #FFF" depressed @click="loadMore">{{$t('loadMore')}}</v-btn>
                </v-flex>
              </v-layout>
            </template>
          </v-sheet>
        </v-col>

      </v-row>
    </template>


    <!--
    <div
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="isLoading"
      infinite-scroll-distance="10"
    ></div>
    -->
<!--    <v-dialog v-model="isLoading" persistent width="300">-->
<!--      <v-card color="dark" dark>-->
<!--        <v-card-text>-->
<!--          Loading...-->
<!--          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>-->
<!--        </v-card-text>-->
<!--      </v-card>-->
<!--    </v-dialog>-->

    <Footer></Footer>
  </v-content>
</template>

<script>
import Header from "../components/Header";
import Footer from "../components/Footer";
import Service from "../services";
import Loading from 'vue-loading-overlay';
import ReportGroup from "../components/ReportGroup";
import { mapActions, mapState } from "vuex";
import {domain} from "../services/Constants";

export default {
  name: "research-and-report",
  components: {
    Header,
    Footer,
    ReportGroup,
    Loading
  },
  data: () => ({
    loaded: false,
    http: domain,
    isLoading: false,
    chartQty: [],
    selectCategory: [],
    selectedCategory: null,
    keyword: "",
    articles: [],
    activeArticles: [],
    current_page: 0,
    has_more: true
  }),
  computed: {
    ...mapState({
      language: state => state.locale.language,
      researchReportBanner: state => state.banner.researchReportBanner,
      industries: function (state) {
        return [
          {
            value: null,
            text: this.$i18n.t('general.select-industry')
          },
          ...state.industry.industries.map(industry => ({
            value: industry.id,
            text: industry[`name_${state.locale.language}`],
            icon_path: industry.icon_path
          }))
        ]
      },
    })
  },
  created() {
    // Google analytic page view
    Service.analytics.sendPageView({
      path: this.$route.path
    })

    this.$store.dispatch('banner/onGetAllBanners');
    // Service.chartdata
    //   .getAllChartData()
    //   .then(res => {
    //     this.chartQty = res;
    //     this.selectCategory = res;
    //     this.selectCategory.unshift({ industry: "ทั้งหมด", id: "ทั้งหมด" });
    //   })
    //   .then(() => {
    //     this.loaded = true;
    //   });
    this.industries[0].name = this.searchAll;

    this.loadMore();

    this.populateIndustries()
  },
  methods: {
    ...mapActions("industry", ["populateIndustries"]),
    loadMore() {
      this.isLoading = true;
      setTimeout(() => {
        Service.webdata
          .getArticles({ page: this.current_page + 1 })
          .then(res => {
            res.data.map(item => {
              this.articles.push(item);
            });

            this.activeArticles = this.articles;
            if (this.articles.length < res.total) {
              this.current_page = res.current_page;
            } else {
              this.has_more = false;
            }
          });
        this.isLoading = false;
      }, 1000);
    },
    onSearchClicked() {
      const params = {
        page: 1,
        industry_id: this.selectedCategory
      };
      params[`name_${this.language}`] = this.keyword;

      Service.webdata.getArticles(params).then(res => {
        this.activeArticles = res.data;
      });
    },
    onIndustryChanged() {
      //TODO load
      console.log(this.selectedCategory);
      if (this.selectedCategory && this.selectedCategory < 16) {
        this.activeArticles = this.articles.filter(x => {
          return x.industry_id === this.selectedCategory;
        });
      } else {
        this.activeArticles = this.articles;
      }
    }
  }
};
</script>

<style scoped>
.headIndex {
  font-size: 20px;
  font-weight: bold;
}

.tableTxt {
  font-size: 17px;
  color: #fff !important;
}

th.tdHead {
  background-color: #ff5100;
  font-size: 15px;
}

/* table border style */
.theme--light.v-data-table tbody tr td {
  border-bottom: 1px solid #ff5100 !important;
}

.theme--light.v-data-table thead tr th:nth-child(even):not(:first-child) {
  color: #ff5100 !important;
}

.theme--light.v-data-table tbody tr td:not(:last-child),
.theme--light.v-data-table thead tr:last-child th:not(:last-child) {
  border-right: 1px solid #ff5100;
}
/* end table border style */

.coloredTxt {
  color: #ff5100;
}
</style>
